module.exports = __webpack_public_path__ + "img/server2.dfc3533.png";